import React, { useState, useEffect } from "react";
import Table from "components/Table";
import PropTypes from "prop-types";

import eightAxios from "configs/axiosConfig";

import BlockIcon from "@material-ui/icons/Block";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import Modal from "components/Modal";
import { TextField, Grid } from "@material-ui/core";
import Filter from "components/Filter";
import { useHistory } from "react-router-dom";
import { useNotifyContext } from "components/Notify";
import { fetchDataFromApi, getAssignedModule } from "utils";
import {
  BLOCK_FETCH_URL,
  DIVISION_FETCH_URL,
  ESTATE_FETCH_URL,
  REGION_FETCH_URL,
  ROLES_URL,
  STORAGE_CONSTANT,
  ZONE_FETCH_URL,
} from "configs/constants";
import { COMPANY_FETCH_URL } from "configs/constants";

const model = [
  { id: "employee_id", label: "Employee ID", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "role", label: "Role", type: "string" },
  { id: "id_number", label: "ID Number", type: "string" },
  { id: "mobile_number", label: "Mobile Number", type: "string" },
  { id: "zone", label: "Zone", type: "string" },
  { id: "region", label: "Region", type: "string" },
  { id: "estate", label: "Estate", type: "string" },
  { id: "division", label: "Division", type: "string" },
  { id: "block", label: "Block", type: "string" },
  { id: "active_approval_request", label: "Ative Approval Request", type: "string", hidden: true },

];

const urls = {
  proxyURL: "user/pending-profiles/",
  exportURL: "user/pending-profiles/export/",
  approveURL: "user/{id}/approve-profile/",
  declineURL: "user/{id}/decline-profile/",
};

const RemarkBody = ({ setRemarks, errorMessage }) => {
  const remarksHandler = (event) => {
    event.preventDefault();
    setRemarks(event.target.value);
  };
  return (
    <Grid container direction="column" spacing={2} style={{ padding: "10px" }}>
      <Grid item>
        <TextField
          variant="outlined"
          name="description"
          fullWidth
          multiline
          rows={3}
          inputProps={{ maxLength: 50 }}
          onChange={remarksHandler}
        />
        <Grid item justify="center">
          {errorMessage ? (
            <p style={{ textAlign: "center", color: "red" }}>{errorMessage}</p>
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  );
};
RemarkBody.propTypes = {
  setRemarks: PropTypes.func,
  errorMessage: PropTypes.string,
};

const PendingApprovalList = () => {
  const [remarks, setRemarks] = useState("");
  const [roles, setRoles] = useState([]);
  const [stateToRefresh, setStateToRefresh] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [filterValues, setFilterValues] = useState({});
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);
  const [disableZone, setDisableZone] = useState(true);

  const [modalFields, setModalFields] = useState({
    id: null,
    title: "Add Remarks",
    isOpen: false,
    body: null,
    confirmButtonLabel: "Reject User",
    onConfirm: null,
    resetModalBodyState: () => setErrorMessage(""),
  });
  const setNotify = useNotifyContext();
  const history = useHistory();
  const pageNumberDropdown = true;

  const filterFields = [
    {
      type: "input",
      name: "employee_id",
      label: "Employee ID",
    },
    {
      type: "input",
      label: "Name",
      name: "name",
    },
    {
      type: "input",
      label: "Mobile Number",
      name: "mobile_number",
    },
    {
      type: "input",
      label: "ID Number",
      name: "id_number",
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
  
  
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      disabled:disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      paginated: true,
      disabled:disableEstate,
      getValue: (e) => getEstateValues(e, setDisableDivision),

      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "division",
      label: "Division",
      proxyUrl: DIVISION_FETCH_URL,
      paginated: true,
      disabled:disableDivision,
      getValue: (e) => getDivisonValues(e, setDisableBlock),

      optionsDependsOn: "estate",
    },
    {
      type: "reactselect",
      name: "block",
      label: "Block",
      proxyUrl: BLOCK_FETCH_URL,
      paginated: true,
      disabled:disableBlock,

      optionsDependsOn: "division",
    },
    {
      type: "reactselect",
      name: "role",
      label: "Role",
      proxyUrl: ROLES_URL,
      paginated: false,
      isPaginationEnabled: false,
      discardOptionsByProperties: {
        keys: ["mobile_access"],
        values: [false],
      },
    },
  ];

  const filterInitialValues = {
    employee_id: "",
    name: "",
    mobile_number: "",
    id_number: "",
    company: "",
    zone: "",
    region: "",
    estate: "",
    division: "",
    block: "",
    role: "",
    active_approval_request: "",
  };

  useEffect(() => {
    fetchDataFromApi(ROLES_URL, setRoles, true);
  }, []);
 
  useEffect(() => {
    const roles_with_mobile_access = roles.find(
      (role) => role.mobile_access === false
    );
    if (roles.includes(roles_with_mobile_access)) {
      setRoles(roles.filter((item) => item.mobile_access === true));
    }
  }, [roles]);
  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };

  const getZoneValues = (e,setDisableRegion) => {
    if (!e || e.length === 0) {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }
    
  };
  const getRegionValues = (e,setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }
    
  };

  const getEstateValues = (e,setDisableDivision) => {
    if (!e || e.length === 0) {
      setDisableDivision(true);
    }
    else {
      setDisableDivision(false);
    }
    
  };
  const getDivisonValues = (e,setDisableBlock) => {
    if (!e || e.length === 0) {
      setDisableBlock(true);
    }
    else {
      setDisableBlock(false);
    }
    
  };

  const approveWorker = (id) => {
    eightAxios
      .patch(urls.approveURL.replace("{id}", id))
      .then((response) => {
        setStateToRefresh(!stateToRefresh);
        setNotify({
          isOpen: true,
          message: response.data.message,
          type: "success",
        });
        history.go(0);
      })
      .catch(() => {
        setNotify({
          isOpen: true,
          message: "User approve failed. Please try again.",
          type: "error",
        });
      });
  };

  useEffect(() => {
    setModalFields({
      ...modalFields,
      body: <RemarkBody errorMessage={errorMessage} setRemarks={setRemarks} />,
      onConfirm: () => {
        eightAxios
          .patch(urls.declineURL.replace("{id}", modalFields.id), {
            remarks: remarks,
          })
          .then((response) => {
            setModalFields({ ...modalFields, isOpen: false });
            setNotify({
              isOpen: true,
              message: response.data.message,
              type: "success",
            });
            history.go(0);
          })
          .catch((error) => {
            if (error.response) {
              let errMsg = "";
              for (let key in error.response.data) {
                errMsg += error.response.data[key] + "\n";
              }
              setErrorMessage(errMsg);
              setNotify({
                isOpen: true,
                message: "User decline failed. Please try again.",
                type: "error",
              });
            } else {
              setErrorMessage(error.message);
              setNotify({
                isOpen: true,
                message: "User decline failed. Please try again.",
                type: "error",
              });
            }
          });
      },
    });
  }, [modalFields.id, errorMessage, remarks]);

  const declineWorker = (id) => {
    setModalFields({
      ...modalFields,
      id: id,
      isOpen: true,
    });
  };

  const actions = [
    {
      type: "approve",
      title: "Approve",
      icon: <CheckCircleOutlineIcon style={{ color: "green" }} />,
      onClick: (id) => approveWorker(id),
    },
    {
      type: "decline",
      title: "Decline",
      icon: <BlockIcon color="primary" />,
      onClick: (id) => declineWorker(id),
    },
  ];

  let module = getAssignedModule(location.pathname);
  let actionPermission = false;
  if (!module || module === "") {
    actionPermission = true;
  } else {
    let updatedModules = JSON.parse(
      localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
    );
    if (updatedModules[module]) {
      let modulePermissions = updatedModules[module].map((perm) => {
        if (typeof perm === "string") {
          return perm.toLowerCase();
        }
        return perm;
      });
      if (modulePermissions.includes("change status")) {
        actionPermission = true;
      }
    }
  }

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };
  const clearFilter =()=>{
    filterInitialValues.status = null
    window.location.reload();
   }

  return (
    <div>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
        onClear={clearFilter}


      />
      <Table
        proxyURL={urls.proxyURL}
        model={model}
        actions={actionPermission ? actions : null}
        excelExport={{ fileName: "Pending" }}
        filterValues={filterValues}
        noAddButton
        noFilter
        pageNumberDropdown={pageNumberDropdown}

      />
      <Modal modalFields={modalFields} setModalFields={setModalFields} />
    </div>
  );
};

export default PendingApprovalList;
